/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import {
  Button,
  Paper,
  Container,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import { ExpandMore as ExpandMoreIcon } from "@mui/icons-material";
import Color from "../../theme/color";
import { usePersistentState } from "../../contexts/global-context";
import { POST } from "../../config/https";
import APIS from "../../config/api";
import toast from "react-hot-toast";
import {
  isEmpty,
  isValidEmail,
  isValidPhoneNumber,
} from "../../utils/validator";
import ValidationError from "../../components/validation-error-label";
import FullScreenLoader from "../../components/full-screen-loader";
import { useLocation, useNavigate } from "react-router-dom";
import { IMaskInput } from "react-imask";
import PaymentForm from "./payment-form";
import { GetLocalStorage } from "../../utils/local-storage";

interface CustomProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
}

const TextMaskCustom = React.forwardRef<HTMLInputElement, CustomProps>(
  function TextMaskCustom(props, ref) {
    const { onChange, ...other } = props;
    return (
      <IMaskInput
        label="xyz"
        {...other}
        mask="(#00) 000-0000"
        definitions={{
          "#": /[1-9]/,
        }}
        inputRef={ref}
        onAccept={(value: any) =>
          onChange({ target: { name: props.name, value } })
        }
        overwrite
      />
    );
  }
);

export default function AddressForm() {
  const navigate = useNavigate();
  const location: any = useLocation();
  const [state, dispatch]: any = usePersistentState();
  const [formErrors, setFormErrors] = useState<Record<string, string>>({
    email: "",
    couponCode: "",
  });
  const [isValidation, setIsValidation] = useState(false);
  const [validation, setValidation] = useState(false);

  const [validatorError, setValidatorErrors] = useState<Record<string, string>>(
    {
      firstName: "",
      lastName: "",
      phone: "",
      email: "",
    }
  );

  const [loader, setLoader] = useState(false);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
  });
  const [couponCode, setCouponCode] = useState("");
  const [error, setErrors] = useState("");
  const [first, setFirst] = useState(true);
  const [expandedAccordion, setExpandedAccordion] = useState<string | false>(
    false
  );

  const checkOutData = GetLocalStorage("CheckOutData");
  const checkOutDataEventDetail = GetLocalStorage("CheckOutDataEventDetail");
  const paymentTypeId = GetLocalStorage("paymentTypeId");
  const couponInfo = GetLocalStorage("CouponInfo");

  useEffect(() => {
    const coupon = GetLocalStorage("CouponInfo");
    dispatch({ couponInfo: coupon });
  }, []);
  useEffect(() => {
    if (isValidation) {
      validator();
    }
  }, [isValidation, error]);
  useEffect(() => {
    if (!first) {
      setFirst(false);
      handleResetChargeCalculation();
    }
  }, [state.ResetAmount]);

  useEffect(() => {
    if (validation) {
      formValidator();
    }
  }, [validation, formData]);

  useEffect(() => {
    let newData = { ...checkOutData, detail: formData };
    localStorage.setItem("CheckOutData", JSON.stringify(newData));
    const savedData = localStorage.getItem("CheckOutData");
    dispatch({ CheckOutData: newData });
  }, [formData]);

  const handleAccordionChange =
    (panel: string) => (event: React.ChangeEvent<{}>, isExpanded: boolean) => {
      setExpandedAccordion(isExpanded ? panel : false);
    };

  useEffect(() => {
    const savedData = localStorage.getItem("formData");
    if (savedData) {
      const parsedData = JSON.parse(savedData);
      setFormData(parsedData);
    }
  }, []);

  const validator = () => {
    const errors: Record<string, string> = {};
    if (isEmpty(couponCode)) {
      errors.couponCode = "Please enter a coupon code";
    } else if (error) {
      errors.couponCode = error;
    } else {
      delete errors.couponCode;
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const formValidator = () => {
    const errors: Record<string, string> = {};
    if (isEmpty(formData.firstName)) {
      errors.firstName = "Please enter an first Name";
    }

    if (isEmpty(formData.lastName)) {
      errors.lastName = "Please enter an last Name";
    }
    if (isEmpty(formData.phone)) {
      errors.phone = "Please enter an phone";
    }

    if (isEmpty(formData.email)) {
      errors.email = "Please enter an email";
    } else if (!isValidEmail(formData.email)) {
      errors.email = "Please enter a valid email";
    } else {
      delete errors.email;
    }

    setValidatorErrors(errors);

    return Object.keys(errors).length === 0;
  };

  const onChangeForm = (event: any, key: string) => {
    let newData = { ...formData };
    switch (key) {
      case "firstName":
        newData.firstName = event.target.value;
        break;
      case "lastName":
        newData.lastName = event.target.value;
        break;
      case "phone":
        newData.phone = event.target.value;
        break;
      case "email":
        newData.email = event.target.value;
        break;
      case "couponCode":
        setCouponCode(event.target.value);
        validator();
        break;
    }

    setFormData(newData);
  };
  const calculateSubTotal = () => {
    const test: any = checkOutData?.final;
    if (test && test.final) {
      return test.final.reduce(
        (subTotal: number, product: any) => subTotal + product.amount,
        0
      );
    }
    return 0;
  };

  const subTotal = calculateSubTotal();

  const handleCheckOutPayment = async (key: string, id: number, isAgree: boolean) => {
    if (!isAgree) {
      return toast.error("Please check i agree to the privacy and policy");
    }
    let checkTemp = checkOutData;
    let orderSummeryDtoData = checkTemp?.final?.map((x: any) => {
      return { ticketConfigId: x?.id, ticketType: x?.ticketType, qty: x?.qty, price: x?.price, };
    });

    let isValid: any = [];
    if (isEmpty(checkOutData?.detail?.firstName ?? "")) {
      isValid.push("Please Enter First Name ");
    }
    if (isEmpty(checkOutData?.detail?.lastName ?? "")) {
      isValid.push("Please Enter Last Name");
    }
    if (isEmpty(checkOutData?.detail?.phone ?? "")) {
      isValid.push("Please Enter Phone Number");
    } else if (!isValidPhoneNumber(checkOutData?.detail?.phone)) {
      isValid.push("Invalid Phone Number");
    }
    if (isEmpty(checkOutData?.detail?.email ?? "")) {
      isValid.push("Please Enter Email");
    }

    if (isValid.length > 0) {
      return toast.error(isValid.join("\n"));
    }
    setLoader(true);
    // debugger;
    let param = {
      customerDto: {
        firstName: checkOutData?.detail?.firstName,
        lastName: checkOutData?.detail?.lastName,
        phone: checkOutData?.detail?.phone,
        email: checkOutData?.detail?.email,
      },
      orderDto: {
        tax: checkOutData?.tax,
        serviceFees: checkOutData?.serviceFees,
        subTotal: checkOutData?.subTotal,

        total: checkOutData?.totalTicketPrices,
        eventId: checkOutDataEventDetail.eventId,
        discount: checkOutData?.couponDiscountPrice,
        paymentTypeId: paymentTypeId,
      },
      couponCode: couponInfo?.couponCode,
      ordersItemDto: orderSummeryDtoData,
    };

    await POST(APIS.CHECKOUT, param)
      .then((res: any) => {
        if (res?.isSuccess) {
          dispatch({ customerInfo: res?.result });
          localStorage.setItem("CustomerInfo", JSON.stringify(res?.result));

          setLoader(false);
          navigate(`/checkout-successful/${res?.result?.customerDetail?.id}`, { replace: true });
        } else {
          toast.error(res?.errors[0]);
          setLoader(false);
        }
      })
      .catch((error) => {
        setValidation(false);
        setLoader(false);
      });
  };

  const handleChargeCalculation = async () => {
    setIsValidation(true);
    setLoader(true);
    // Validate coupon code first
    if (isEmpty(couponCode)) {
      setFormErrors({ ...formErrors, couponCode: "Please enter a coupon code" });
      setLoader(false);
      return;
    }
    // Store current form data in a variable to ensure we use the latest state
    const currentFormData = { ...formData };
    let checkTemp = checkOutData;

    let ticketConfigs = checkTemp?.final?.map((x: any) => {
      return {
        id: x?.id,
        qty: x?.qty,
      };
    });
    let param = {
      couponCode: couponCode,
      email: currentFormData.email, // Use the stored currentFormData
      eventId: checkOutDataEventDetail?.eventId,
      ticketConfigs: ticketConfigs,
      paymentType: paymentTypeId || 1002,
    };
    await POST(APIS.CHARGE_CALCULATION, param)
      .then((res: any) => {
        if (res?.isSuccess) {
          localStorage.setItem("CouponInfo", JSON.stringify(res?.result));
          dispatch({ couponInfo: res?.result });
          toast.success("Coupon applied");
          setCouponCode("");
          setFormErrors({ email: "", couponCode: "", phone: "" });
          setErrors("");
          setIsValidation(false);
          // Use currentFormData to preserve the form state
          let temp = {
            ...checkOutData,
            detail: currentFormData, // Use currentFormData instead of tempFormData
            totalTicketPrices: res?.result?.total,
            tax: res?.result?.tax,
            serviceFees: res?.result?.serviceFees,
            subTotal: res?.result?.subTotal,
            couponDiscountPrice: res?.result?.couponDiscountPrice,
          };
          dispatch({ CheckOutData: temp });
          localStorage.setItem("CheckOutData", JSON.stringify(temp));
          setLoader(false);
        } else {
          const errorMessage = res.errors[0].toString();
          setFormErrors({ ...formErrors, couponCode: errorMessage });
          setErrors(errorMessage);
          validator();
        }
      })
      .catch((error) => {
        setLoader(false);
      })
      .finally(() => {
        setLoader(false);
      });
  };
  const handleResetChargeCalculation = async () => {
    setLoader(true);
    let checkTemp = checkOutData;

    let ticketConfigs = checkTemp?.final?.map((x: any) => {
      return {
        id: x?.id,
        qty: x?.qty,
      };
    });
    // Use current formData state
    const currentFormData = { ...formData };
    let param = {
      couponCode: "",
      email: currentFormData.email,
      eventId: checkOutDataEventDetail?.eventId,
      ticketConfigs: ticketConfigs,
      paymentType: paymentTypeId,
    };
    await POST(APIS.CHARGE_CALCULATION, param)
      .then((res: any) => {
        if (res?.isSuccess) {
          setCouponCode("");
          setFormErrors({ email: "", couponCode: "", phone: "" });
          dispatch({ couponInfo: res?.result });
          localStorage.setItem("CouponInfo", JSON.stringify(res?.result));
          let temp = {
            ...checkOutData,
            detail: currentFormData, // Preserve form data
            totalTicketPrices: res?.result?.total,
            tax: res?.result?.tax,
            serviceFees: res?.result?.serviceFees,
            subTotal: res?.result?.subTotal,
            couponDiscountPrice: res?.result?.couponDiscountPrice,
          };
          dispatch({ CheckOutData: temp });
          localStorage.setItem("CheckOutData", JSON.stringify(temp));
        } else {
          // Handle error
        }
      })
      .catch((error) => {
        console.log("error", error);
      })
      .finally(() => {
        setLoader(false);
      });
  };

  return (
    <Container maxWidth="lg">
      <Paper
        style={{
          marginTop: "10px",
          width: "100%",
          boxShadow: "0 1px 2px 0 rgba(0,0,0,.25)",
        }}
      >
        <FullScreenLoader open={loader} />
        <Accordion
          expanded={expandedAccordion === "couponAccordion"}
          onChange={handleAccordionChange("couponAccordion")}
        >
          <AccordionSummary
            style={{ backgroundColor: "#77b978" }}
            expandIcon={<ExpandMoreIcon style={{ color: "#fff" }} />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography style={{ color: "white" }} variant="h6">
              Have a coupon?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography
              variant="body2"
              style={{ color: "GrayText", marginBottom: "10px" }}
            >
              If you have a coupon code, please apply it below.
            </Typography>

            <Grid container spacing={2}>
              <Grid item xs={12} md={8}>
                <TextField
                  value={couponCode}
                  fullWidth
                  placeholder="Coupon Code"
                  size="small"
                  variant="outlined"
                  onChange={(event: any) => {
                    setCouponCode(event.target.value);
                  }}
                />
                <div>
                  <ValidationError formErrors={formErrors.couponCode} />
                </div>
              </Grid>
              <Grid item xs={12} md={4}>
                <Button
                  size="medium"
                  variant="contained"
                  style={{ backgroundColor: Color.primary }}
                  fullWidth
                  onClick={handleChargeCalculation}
                >
                  Apply Coupon
                </Button>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
      </Paper>

      {!loader && (
        <Paper
          style={{
            marginTop: "20px",
            width: "100%",
            padding: "10px",
          }}
          variant="outlined"
        >
          <Typography
            variant="h4"
            style={{ color: "GrayText", paddingLeft: "10px" }}
            gutterBottom
          >
            Billing details
          </Typography>
          <Grid container spacing={2} style={{ padding: "10px" }}>
            <Grid item xs={12} sm={6}>
              <TextField
                required
                id="firstName"
                name="firstName"
                label="First name"
                fullWidth
                autoComplete="given-name"
                variant="standard"
                value={formData.firstName}
                onChange={(event) => onChangeForm(event, "firstName")}
              />
              <ValidationError formErrors={validatorError.firstName} />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                required
                id="lastName"
                name="lastName"
                label="Last name"
                fullWidth
                autoComplete="family-name"
                variant="standard"
                value={formData.lastName}
                onChange={(event) => onChangeForm(event, "lastName")}
              />
              <ValidationError formErrors={validatorError.lastName} />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Phone Number *"
                placeholder="(000) 000-0000"
                fullWidth
                variant="standard"
                value={formData.phone}
                onChange={(event) => onChangeForm(event, "phone")}
                name="PhoneNumber"
                id="formatted-text-mask-input"
                InputProps={{
                  inputComponent: TextMaskCustom as any,
                }}
              />
              <ValidationError formErrors={validatorError.phone} />
            </Grid>
            <Grid item xs={12}>
              <TextField
                id="email"
                name="email"
                label="Email *"
                fullWidth
                autoComplete="email"
                variant="standard"
                value={formData.email}
                onChange={(event) => onChangeForm(event, "email")}
              />
              <div>
                <ValidationError
                  formErrors={formErrors.email || validatorError.email}
                />
              </div>
            </Grid>
          </Grid>
          <PaymentForm handleCheckOut={(key, id, isAgree) => handleCheckOutPayment(key, id, isAgree)} />
        </Paper>
      )}
    </Container>
  );
}